export default {
  formFields: {
    fieldHelp: 'Faceți clic pentru a deschide descrierea',
    defaultAbbreviation: 'df.: ',
    paramJSONContent: 'Conținutul JSON',
    wrongInputValue: 'Valoare de intrare greșită pentru acest parametru.',
    notValidJsonString: 'Nu există Json valid pentru :fieldName',
  }
}
